<template>
    <div class="container-etoiles w-50">
        <div class="container-animation-etoiles position-relative">
            <img
                v-for="index in 5"
                :key="index"
                :src="getEtoileSrc( index )"
                alt="etoile"
                :class="[ 'etoile', 'etoile-' + index ]"
            />
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'EtoileComponent',
        props: {
            score_etoile: {
                type: Number,
                default: 1,
            },
        },
        methods: {
            getEtoileSrc( index ) {
                return index <= this.score_etoile
                ? 'images/bilan/etoile-pleine.svg'
                : 'images/bilan/etoile-vide.svg';
            },
        },
    };
</script>